module.exports = __webpack_public_path__ + "img/sixpackcarrier61.90f851eb.jpg";